/**
 * Global Helmet Settings
 */
import tr, { currentLang } from '../../../../locales';

import * as React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

interface IOwnStateProps {
  businessInformation: GQL.IBusinessInformation;
}

type AppHelmetProps = IOwnStateProps;

function AppHelmet(props: AppHelmetProps) {
  const {
    businessInformation: {
      name,
      legal_name,
      address,
      logo,
      phone_numbers,
      website,
      social_media,
    },
  } = props;
  const facebook = social_media!.facebook!;
  const twitter = social_media!.twitter!;
  const image = social_media!.image!;
  const facebookUrl = `https://www.facebook.com/${facebook}`;
  const twitterUrl = `https://www.twitter.com/${twitter}`;
  return (
    <Helmet
      defaultTitle={tr.pageTitles.default}
      titleTemplate={tr.pageTitles.template}
    >
      <html lang={currentLang} data-app-state="running" />
      <meta name="description" property="og:description" content={tr.metaDescriptions.default} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={tr.pageTitles.default} />
      <meta property="og:site_name" content={name} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content={`@${twitter}`} />
      <script type="application/ld+json">{`{
        "@context": "http://schema.org",
        "@type": "WebSite",
        "url": "${website}",
        "name": "${name}",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "${website}/browse?search=keywords:{search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }`}</script>
      <script type="application/ld+json">{`{
        "@context": "http://schema.org",
        "@type": "Corporation",
        "@id": "https://corporation.boppermusic.com",
        "legalName": "${legal_name}",
        "url": "${website}",
        "description": "${tr.metaDescriptions.default}",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "${address.city}",
          "addressCountry": "${address.country_code}",
          "postalCode": "${address.postal_code}",
          "streetAddress": "${address.line_1}${address.line_2 ? `, ${address.line_2}` : ''}"
        },
        "sameAs": [
          "${facebookUrl}",
          "${twitterUrl}"
        ],
        "name": "${legal_name}",
        "logo": "${logo}",
        "image": "${image}",
        "telephone": "${phone_numbers!.find(({ type }) => type === 'main')!.phone_number}"
      }`}</script>
    </Helmet>
  );
}

const ConnectedAppHelmet = connect<IOwnStateProps, {}, {}, IStoreState>(
  ({ staticData }) => ({
    businessInformation: staticData.businessInformation as GQL.IBusinessInformation,
  }),
)(AppHelmet);

export default ConnectedAppHelmet;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/AppWrapper/helmet.tsx